import {Directive, inject, DestroyRef} from '@angular/core';
import {NgSelectComponent} from '@ng-select/ng-select';

@Directive({
  selector: '[msGridDropdown]',
  standalone: true,
})
export class GridDropdownDirective {
  private readonly select = inject(NgSelectComponent, {self: true});
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    window.addEventListener('scroll', this.onScroll, true);

    this.destroyRef.onDestroy(() => {
      window.removeEventListener('scroll', this.onScroll, true);
    });
  }

  private readonly onScroll = (event: Event): void => {
    if (!this.select.isOpen) {
      return;
    }

    const target = event.target as HTMLElement | null;
    const isDropdownScroll = target?.className?.includes('ng-dropdown-panel-items');

    if (isDropdownScroll) {
      return;
    }

    this.select.close();
  };
}
